import { useState } from "react";
import { Popover } from "@mui/material";
import OtCustomFilters from "./OtCustomFilters";
import { ColumnsButton, ExportCsvButton, FilterButton, GridToolbarBar, ToolbarGroup, ToolbarSpacer } from "./ToolbarKit";

const OtToolBar = ({ filterModel, setFilterModel, mode = null }) => {
  const [anchor, setAnchor] = useState(null);

  return (
    <GridToolbarBar>
      <ToolbarGroup>
        <ColumnsButton />
        <FilterButton count={filterModel.length} onClick={(e) => setAnchor(e.currentTarget)} />
      </ToolbarGroup>

      <ToolbarSpacer />
      <ExportCsvButton />

      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{ paper: { sx: { p: 1 } } }}
      >
        <OtCustomFilters filterModel={filterModel} setFilterModel={setFilterModel} mode={mode} />
      </Popover>
    </GridToolbarBar>
  );
};

export default OtToolBar;
